/* eslint-disable max-len */
const React = require('react');

const Download = ({ alt }) => (
  <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={alt || ''}>
    <path d="M5.69992 9.15148L9.9048 13.3564L9.89964 2.19529L11.0996 2.19473L11.1048 13.3466L15.2999 9.15148L16.1484 10L10.4999 15.6485L4.85139 10L5.69992 9.15148Z" fill="#009EE3"/>
    <path d="M18.3001 17.7998L2.70012 17.8052L2.69971 16.6052L18.2997 16.5998L18.3001 17.7998Z" fill="#009EE3" />
  </svg>
);

module.exports = Download;
